/**
  @module @ember-data/store
*/

/**
 * This symbol provides a Symbol replacement for browsers that do not have it
 * (eg. IE 11).
 *
 * The replacement is different from the native Symbol in some ways. It is a
 * function that produces an output:
 * - iterable;
 * - that is a string, not a symbol.
 *
 * @internal
 */
export var symbol = typeof Symbol !== 'undefined' ? Symbol : key => `__${key}${Math.floor(Math.random() * Date.now())}__`;
export function addSymbol(obj, symbol, value) {
  if (typeof symbol === 'string') {
    Object.defineProperty(obj, symbol, {
      value,
      configurable: false,
      enumerable: false,
      writable: false
    });
  } else {
    // Typescript doesn't allow Symbol as an index type
    obj[symbol] = value;
  }
}